export default "__VITE_ASSET__f6e98e99__"